var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeadphone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill-rule: evenodd;\n        filter: url(#filter);\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "filter",
    x: 665,
    y: 4934,
    width: 23,
    height: 25,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "flood",
    floodColor: "#fff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    result: "composite",
    operator: "in",
    in2: "SourceGraphic"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "blend",
    in2: "SourceGraphic"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "headphone.svg",
    className: "cls-1",
    d: "M684.866,4943.51v-0.96a8.9,8.9,0,0,0-2.24-6.03,7.639,7.639,0,0,0-5.733-2.52h-0.776a7.639,7.639,0,0,0-5.733,2.52,8.9,8.9,0,0,0-2.24,6.03v0.96a3.415,3.415,0,0,0-3.144,3.43v1.5a3.405,3.405,0,0,0,3.365,3.44h1.9a0.623,0.623,0,0,0,.616-0.63v-7.12a0.623,0.623,0,0,0-.616-0.63h-0.884v-0.95c0-4.16,2.9-7.29,6.735-7.29h0.776c3.842,0,6.735,3.13,6.735,7.29v0.95h-0.884a0.623,0.623,0,0,0-.616.63v7.12a0.629,0.629,0,0,0,.616.63H683.6c-0.252,3.29-2.466,4.05-3.493,4.22a2.173,2.173,0,0,0-2.06-1.53h-1.541a2.216,2.216,0,0,0,0,4.43h1.546a2.173,2.173,0,0,0,2.086-1.63,5.726,5.726,0,0,0,2.09-.73,5.59,5.59,0,0,0,2.61-4.77,3.407,3.407,0,0,0,3.16-3.43v-1.5A3.4,3.4,0,0,0,684.866,4943.51Zm-15.212,7.11h-1.279a2.16,2.16,0,0,1-2.132-2.18v-1.5a2.154,2.154,0,0,1,2.132-2.18h1.279v5.86Zm8.4,7.12h-1.546a0.95,0.95,0,0,1,0-1.9h1.546A0.95,0.95,0,0,1,678.054,4957.74Zm8.718-9.3a2.16,2.16,0,0,1-2.132,2.18h-1.279v-5.86h1.279a2.154,2.154,0,0,1,2.132,2.18v1.5Z",
    transform: "translate(-665 -4934)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphone);
export default __webpack_public_path__ + "static/media/headphone.16f8b4a5750a635e68ae51599942b082.svg";
export { ForwardRef as ReactComponent };